module.exports = __webpack_public_path__ + "assets/icon_training.f9109614.svg";